export default __webpack_public_path__ + "static/sizzle-5eb0712cfa64a22f328333ae7da087e2.mp4";